module.exports = __webpack_public_path__ + "img/bn_servicios.63b5ed5.svg";